export const parseIntInput = <T>(raw: string, fallback: T): number | T => {
  if (raw === '') return fallback;

  const parsed = Number.parseInt(raw, 10);

  return Number.isFinite(parsed) ? parsed : fallback;
};

export const parseFloatInput = <T>(raw: string, fallback: T): number | T => {
  if (raw === '') return fallback;

  const parsed = Number.parseFloat(raw);

  return Number.isFinite(parsed) ? parsed : fallback;
};

const NON_DECIMAL_NUMERIC_LITERAL_RE = /^[+-]?0[xXbBoO]/;
const SCIENTIFIC_NOTATION_RE = /[eE]/;
const MORE_THAN_TWO_DECIMAL_PLACES_RE = /\.\d{3,}$/;

export const parseStrictFloat = (raw: string): number | null => {
  const trimmed = raw.trim();

  if (trimmed === '') return null;

  if (NON_DECIMAL_NUMERIC_LITERAL_RE.test(trimmed)) return null;

  if (SCIENTIFIC_NOTATION_RE.test(trimmed)) return null;

  const parsed = Number(trimmed);

  return Number.isFinite(parsed) ? parsed : null;
};

export const hasMoreThanTwoDecimalPlaces = (raw: string): boolean => MORE_THAN_TWO_DECIMAL_PLACES_RE.test(raw.trim());

export const hasAtMostTwoDecimalPlaces = (n: number): boolean => Number(n.toFixed(2)) === n;

export const coerceIntFromUnknown = <T>(raw: unknown, fallback: T): number | T => {
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : fallback;

  return parseIntInput(String(raw ?? ''), fallback);
};

export const coerceFloatFromUnknown = <T>(raw: unknown, fallback: T): number | T => {
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : fallback;

  return parseFloatInput(String(raw ?? ''), fallback);
};

const LEADING_ZEROS_DECIMAL_RE = /^(\d+)(\.\d*)?$/;

export const stripLeadingZeros = (raw: string): string => {
  const match = LEADING_ZEROS_DECIMAL_RE.exec(raw);

  if (!match) return raw;

  const [, intPart, fracPart = ''] = match;
  const normalizedInt = intPart.replace(/^0+(?=\d)/, '');

  return `${normalizedInt}${fracPart}`;
};
